import React from 'react';

export interface VerticalSpaceProps {
  height?: number;
}

export const VerticalSpace: React.FC<VerticalSpaceProps> = (props) => {
  const { height = 0 } = props;

  return <div style={{ height: `${height}px` }} />;
};
